// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__7Uu24"};